import React from "react";
import {Route, Routes} from "react-router-dom";
import RootPage from "./root-page/RootPage.tsx";

const AppRoutes: React.FC = () => {

    return (
        <Routes>
            <Route path="index.html" element={<RootPage/>}/>
        </Routes>
    );
}

export default AppRoutes;